'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _timers = require('core-js/library/web/timers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var log = require('../utils/logger')('splitio-events');
var tracker = require('../utils/timeTracker');

var _require = require('../utils/constants'),
    LOCALHOST_MODE = _require.LOCALHOST_MODE;

var repeat = require('../utils/fn/repeat');

var eventsService = require('../services/events');
var eventsBulkRequest = require('../services/events/bulk');

var EventsFactory = function EventsFactory(context) {
  var settings = context.get(context.constants.SETTINGS);
  var storage = context.get(context.constants.STORAGE);
  var isLocalhostMode = settings.mode === LOCALHOST_MODE;

  var pushEvents = function pushEvents() {
    if (isLocalhostMode || storage.events.isEmpty()) return _promise2.default.resolve();

    log.info('Pushing ' + storage.events.state().length + ' queued events.');
    var latencyTrackerStop = tracker.start(tracker.TaskNames.EVENTS_PUSH);
    var json = (0, _stringify2.default)(storage.events.toJSON());
    storage.events.clear(); // we always clear the queue.

    return eventsService(eventsBulkRequest(settings, {
      body: json
    })).then(function () {
      return latencyTrackerStop();
    });
  };

  var stopEventsPublisher = false;
  var startEventsPublisher = function startEventsPublisher() {
    return stopEventsPublisher = repeat(function (schedulePublisher) {
      return pushEvents().then(function () {
        return schedulePublisher();
      });
    }, settings.scheduler.eventsPushRate);
  };

  return {
    start: function start() {
      // On the browser there may be a wish to wait an specific amount of seconds before the first push.
      if (settings.startup.eventsFirstPushWindow > 0) {
        (0, _timers.setTimeout)(startEventsPublisher, settings.startup.eventsFirstPushWindow);
      } else {
        startEventsPublisher();
      }
    },
    flush: function flush() {
      return pushEvents();
    },
    stop: function stop() {
      stopEventsPublisher && stopEventsPublisher();
    },
    flushAndResetTimer: function flushAndResetTimer() {
      // Reset the timer and push the events.
      log.info('Flushing events and reseting timer.');
      stopEventsPublisher && stopEventsPublisher.reset();
      return pushEvents();
    }
  };
};

module.exports = EventsFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/events/index.js
// module id = 652
// module chunks = 7